import { joyDocHelper } from '@builttocreate/engine-utils';
import { applyLogic } from '@joyfill/conditional-logic';
import JoyDoc from './components/JoyDoc';
import JoyDocExporter from './components/form/exporter/JoyDocExporter';
import { getDuplicatedPageAndChangelogsForDocument } from './lib/documentHelper';

const { getDefaultDocument, getDefaultTemplate, getDocumentFromTemplate, duplicate } = joyDocHelper;

const duplicatePage = getDuplicatedPageAndChangelogsForDocument;

export {
  JoyDoc,
  JoyDocExporter,
  duplicate,
  duplicatePage,
  getDefaultDocument,
  getDefaultTemplate,
  getDocumentFromTemplate,
  applyLogic,
};

export default {
  JoyDoc,
  JoyDocExporter,
  duplicate,
  duplicatePage,
  getDefaultDocument,
  getDefaultTemplate,
  getDocumentFromTemplate,
  applyLogic
};
